
import { useOrderContext } from "./OrderContext";
import { useState, useEffect} from 'react';
import { ENGINE_URL } from "../config";

function Header()
{
  const api = ENGINE_URL;
  const {departamentId, setDepartamentId} = useOrderContext();

  const [departaments, setDepartaments] = useState([]);

  
  useEffect(() => {
      fetch(`${api}/server/public/`, {
        method: "post",
        headers: {
          'Content-Type': "application/json"
        },
        body: JSON.stringify({
          kitchen: 'getDepartaments'
        })
      })
      .then(respons => respons.json())
      .then((data) => {
          setDepartaments(data)
      })
  }, [])
  

  return (
    <header className=" position-fixed start-0 end-0 z-3">
      <ul className="nav nav-tabs bg-dark">
        {
            departaments.map((item) => (
              <li key={item.id} className="nav-item">
                <a className={`nav-link ${departamentId === item.id ? 'active' : ''}`} onClick={() => setDepartamentId(item.id)} href="#">{item.name}</a>
            </li>
          ))
        }
      </ul>
    </header>
  )
}

export default Header;